import Grid from "@mui/material/Grid";
import React from "react";
import { useDispatch } from "react-redux";
import SharedStaticPageHeader from "../../shared/SharedStaticPageHeader/SharedStaticPageHeader";
import {
  ContentContainer,
  LinkContainer,
  LinkStyled,
  TitleStyled,
  Wrapper,
} from "../styles";

const CompanyJobsContent = (props) => {
  const { companies } = props;
  const dispatch = useDispatch();

  const getCompanyName = (company) => {
    if (!company || typeof company !== "string") return "";
    try {
      const decoded = decodeURIComponent(company);
      const spaced = decoded.replace(/-/g, " ");
      const words = spaced.split(" ");
      return words
        .map((word) =>
          /[a-zA-Z]/.test(word)
            ? word.charAt(0).toUpperCase() + word.slice(1)
            : word
        )
        .join(" ");
    } catch (e) {
      return company;
    }
  };

  return (
    <Wrapper>
      <SharedStaticPageHeader page={"Jobs by Company"} />
      <Grid>
        <TitleStyled>Jobs by Company</TitleStyled>
        <ContentContainer>
          {companies.map((company, index) => {
            return (
              <LinkContainer key={index}>
                <LinkStyled href={`/companies/${company.slug}`}>
                  Jobs at {getCompanyName(company.slug)}
                </LinkStyled>
              </LinkContainer>
            );
          })}
        </ContentContainer>
      </Grid>
    </Wrapper>
  );
};

export default CompanyJobsContent;
